<!-- Fixed elements -->
<app-global-message
        [messages]="globalMessages$ | async"
        (dismiss)="dismissGlobalMessage($event)">
</app-global-message>
<app-cookie-notice></app-cookie-notice>
<app-header
        [isLoggedIn]="(isLoggedIn$ | async) && !anonymousPageShowing"
        [hasNonEmptyQuotes]="hasNonEmptyQuotes$ | async"
        [languages]="languages"
        [currentLanguage]="currentLanguage"
        (loggedOut)="logout()"
        (languageSwitched)="switchLanguage($event)"
        (openQuoteViewSelection)="openQuoteViewSelection()"
        (openSiteMenu)="openSiteMenu()">
</app-header>

<mat-sidenav fixedInViewport class="sidenav-burger" (closedStart)="closeSideNav()" position="end"
             [opened]="isSiteMenuOpen$ | async">
    <app-site-menu-page
        [isLoggedIn$]="isLoggedIn$"
        [activatedComponent]="activatedComponent$ | async"
        [languages]="languages"
        [currentLanguage]="currentLanguage"
        (loggedOut)="logout()"
        (languageSwitched)="switchLanguage($event)"
    >
    </app-site-menu-page>
</mat-sidenav>

<ng-container>
    <mat-sidenav *ngIf="isLoggedIn$ | async" fixedInViewport class="sidenav-quotes" (closedStart)="closeQuoteViewSelection()" [position]="windowInnerWidth <= 959 ? 'start' : 'end'"
                 [opened]="isQuoteViewSelectionOpen$ | async">

                 <app-quotes-nav></app-quotes-nav>
    </mat-sidenav>
</ng-container>

<!-- Custom backdrop, triggered manually -->
<div class="mat-drawer-transition">
    <div #backdrop class="mat-drawer-backdrop" [ngClass]="{'mat-drawer-shown': isSideNavOpen$ | async}"></div>
</div>
<!-- Content -->
<div class="container" fxLayout="column">
    <main fxFlex>
        <router-outlet></router-outlet>
        <app-spinner-page *ngIf="!routerOutlet.isActivated"></app-spinner-page>
    </main>
    <app-footer *ngIf="!anonymousPageShowing"></app-footer>
</div>
<!-- Dummy, don't remove -->
<!-- It seems that the mat-sidenav animation logic is handled here. Without that control in the page
     the mat-sidenav doesn't slide in -->
<mat-sidenav-container></mat-sidenav-container>


